import ContactPageCmsContainer from "../../container/admin/contactpage-cms";

const ContactPageCms = () => {
    return <ContactPageCmsContainer />;
};

export default ContactPageCms;